module.exports = __webpack_public_path__ + "img/3.870402d5.png";